import { useQuery } from 'react-query';
import axios from '../../helpers/axios';
import { logError } from '../../services';
import { IDropdownResponse } from '../../models';

export const QUERY_SALES_TOOLS_USERS_LOOKUP = '/api/sales/tools/email-templates/users-lookup';
export const useGetSalesUsersLookup = () => {
  return useQuery({
    queryKey: [QUERY_SALES_TOOLS_USERS_LOOKUP],
    queryFn: () => getSalesUsersLookup()
  });
};

export const getSalesUsersLookup = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(QUERY_SALES_TOOLS_USERS_LOOKUP);
    return data;
  } catch (error) {
    logError(error, 'getSalesUsersLookup failed');
    return Promise.reject(error);
  }
};
